<template>
    <div class="home">
        <header-small></header-small>
        <div>
            <b-container>
                <b-row>
                    <b-col>
                        <h2>Kontakt</h2>
                        <div class="line-wrapper"><span class="line"></span></div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div>
            <b-container>
                <b-row>
                    <b-col>
                        <p class="text-center">
                            Wolfgang Weber<br>
                            Eichgrundweg 9<br>
                            01796 Pirna<br>
                            <br>
                            Telefon: <a href="tel:+493501762432">03501 762432</a><br>
                            Mobile: <a href="tel:+4915157164841">0151 57164841</a><br>
                            E-Mail: <a href="mailto:info@ferienhausvermietung-weber.de">info[at]ferienhausvermietung-weber.de</a>
                        </p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="full-height" style="margin-bottom: -50px">
            <b-container fluid>
                <b-row>
                    <b-col class="px-0">
                        <gmap-map style="height: 400px; max-width: 100%"
                                  :center="{ lat:50.925610, lng:13.963740 }"
                                  :zoom="15"
                                  map-type-id="roadmap"
                        >
                            <gmap-marker :position="{ lat:50.925610, lng:13.963740 }"
                                         :clickable="true"
                            ></gmap-marker>
                        </gmap-map>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Parallax from 'vue-parallaxy'
import AppDetails from '@/components/Details'
import Navigation from '@/components/Navigation'
import HeaderSmall from '@/components/HeaderSmall'

export default {
  name: 'home',
  metaInfo: {
    title: 'Ferienhaus Weber',
    htmlAttrs: {
      lang: 'de'
    },
    meta: [
      { name: 'description', content: 'Unser Ferienhaus liegt zentral zwischen dem Nationalpark Sächsische Schweiz und der Landeshauptstadt Dresden. Sie können Ihren Urlaub abwechslungsreich gestalten. Sie können Wandern, Klettern, Radfahren, oder Museen, Burgen und Städte besichtigen.' },
      { name: 'keywords', content: 'Sächsische Schweiz, Pirna, Dresden, Wanderung, Ländlich, Bergsteigen, Paddeln, Active Urlaub' }
    ]
  },
  components: {
    HeaderSmall,
    Navigation,
    Parallax,
    AppDetails
  }
}
</script>

<style scoped>
    .full-height {
        min-height: calc(100vh - 289px);
    }
</style>
